const API_BASE_URL = process.env.REACT_APP_API_URL;

if (!API_BASE_URL) {
  throw new Error("REACT_APP_API_URL is not defined");
}


export interface TravelData {
  bookingId?: string;

  pickup: string;
  destination: string;
  time: string;

  passengers: number;
  adults?: number;
  children: number;
  babies?: number;

  vehicleType: string;

  returnDate: string;
  returnTime: string;

  specialRequests: string;
  tripDate?: Date | string | null;

  pickupLabel?: string;

  airline?: string;
  flightPrefix?: string;
  flightNumber?: string;

  resort?: string;

  cabinLuggage?: number;
  checkedLuggage?: number;
  childBuggy?: number;
  golfBags?: number;
  surfBoard?: number;
  foldingWheelchair?: number;
  bikeBox?: number;
  mobilityScooters?: number;
  pets?: string;

  country?: string;
  foundUs?: string;
}

export interface BookingData extends TravelData {
  name: string;
  email: string;
  contact: string;
  paymentType: "na-hora" | "agora";
}

export interface CreateQuoteResponse {
  success: boolean;
  bookingId: string;
  amount?: number;
  currency?: string;
  message?: string;
  clientSecret?: string;
}

export async function createQuote(
  data: BookingData
): Promise<CreateQuoteResponse> {
  const res = await fetch(`${API_BASE_URL}/api/quotes`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      ...data,
      tripDate: data.tripDate
        ? new Date(data.tripDate).toISOString()
        : null,
    }),
  });

  const result = await res.json();

  if (!res.ok) {
    throw new Error(result.error || "Erro ao criar reserva");
  }

  return result;
}